<template>
  <div class="cart-row">
    <div class="cart-row-description">
      <span :style="textStyle" class="name-container">{{translatedName}}</span>
      <span :style="textStyle">{{priceToDisplay}}</span>
    </div>
    <div class="quantity-block-props">
        <span class="quantity-props" :style="textStyle">{{cartLine.quantity}} {{translatedUnitText}} x {{cartLine.price}}€</span>
     </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { MultiLanguageText } from '../models';

export default {
  name: 'cart-row-block',
  props: {
    cartLine: { type: Object, required: true },
    textStyle: { type: Object, required: true },
    unitText: { type: Object, required: true },
    quantityTextProps: { type: Object, required: true },
    quantityBlockProps: { type: Object, required: true }
  },
  created() {},
  computed: {
    ...mapGetters(['selectedLanguage']),
    translatedName() {
      return this.cartLine.name.getText(this.selectedLanguage);
    },
    multiLanguageUnitText() {
      return new MultiLanguageText(this.unitText);
    },
    translatedUnitText() {
      return this.multiLanguageUnitText.getText(this.selectedLanguage);
    },
    priceToDisplay() {
      const price = this.cartLine.price * this.cartLine.quantity;
      return `${price.toLocaleString(undefined, { minimumFractionDigits: 2 })}€`;
    }
  },
  watch: {},
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.cart-row {
  display: flex;
  flex-direction: column;
}

.cart-row-description {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.quantity-block-props {
  align-self: flex-end;
  margin-top: 5px;
}

.quantity-props {
  margin: 0 3px;
}

.name-container {
  width: 70%;
}
</style>
